import React, {Component} from 'react';
import {Router, Route, IndexRoute, Link, browserHistory} from 'react-router'
import {
    Navbar,
    Nav,
    NavItem,
    Table,
    Form,
    FormGroup,
    FormControl,
    ControlLabel,
    Button,
    Panel,
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover,
    Checkbox,
    Pager
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap'

//import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

class App extends Component {
    constructor() {
        super()
        this.state = {}
    }

    componentDidMount() {
        api_call({'action': 'hero_list'}, (json) => {
            const hero_list = {};
            json.forEach((item) => {
                hero_list[item.hero_id] = item;
            });
            this.setState({hero_list: hero_list});
        });
        api_call({'action': 'item_list'}, (json) => {
            const item_list = {};
            json.items.forEach((item) => {
                item.builds_to = [];
                item_list[item.item_id] = item;
            });
            json.items.forEach((item) => {
                if (item.components) item.components.forEach((component_item_id) => {
                    item_list[component_item_id].builds_to.push(item.item_id);
                });
            });
            json.banned_items.forEach((item_id) => {
                item_list[item_id].banned = true;
            });
            this.setState({item_list: item_list})
        });
    }

    render() {
        return <div>
            <Navbar inverse fixedTop collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <span>
                                <img width="22" src="/images/dota_2_icon_by_benashvili-d5011np.png" alt="Brand"/>
                                <span className="visible-xs-inline">Dota 2 Item Recommender</span>
                                <span className="hidden-xs">Dota 2 Item Recommender System</span>
                            </span>
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer to="/hero">
                            <NavItem>Heroes</NavItem>
                        </LinkContainer>
                        <LinkContainer to="/player">
                            <NavItem>Players</NavItem>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <div className="container">
                {React.cloneElement(this.props.children, {
                    hero_list: this.state.hero_list,
                    item_list: this.state.item_list
                })}
            </div>
        </div>;
    }
}

class ItemListUnstyled extends Component {
    render() {
        if (!this.props.item_ids || !this.props.item_ids.length) {
            return null;
        }
        // Use index key as item ids can be duplicated.
        return (
            <div>
                <p><b>{this.props.title}</b></p>
                <ul className="list-unstyled">
                    {this.props.item_ids.map((component_item_id, index) => {
                        return (
                            <li key={index}>
                                <Item item_list={this.props.item_list} item_id={component_item_id}/>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

class Item extends Component {
    render() {
        if (!this.props.item_list) {
            return <span>Item {this.props.item_id}</span>
        }
        const item = this.props.item_list[this.props.item_id];
        const img = <img src={"/images/items/" + item.name + ".png"} alt={item.dname} height="20"/>;
        const img_and_text = (
            <span className="item-img-and-text">
                    {img}
                {' '}
                {item.dname}
            </span>
        );
        const popover_title = (
            <span>
                <span>{img_and_text}</span>
                <span style={{float: 'right'}}><img src="/images/Gold_symbol.png" alt="Gold"
                                                    height="20"/> {item.cost}</span>
            </span>
        );
        const popover = (
            <Popover title={popover_title} id="item-popover">
                <p>
                    <small>{item.description}</small>
                </p>
                <ItemListUnstyled item_ids={item.components} item_list={this.props.item_list} title="Builds from"/>
                <ItemListUnstyled item_ids={item.builds_to} item_list={this.props.item_list} title="Builds into"/>
            </Popover>
        );
        let disp = img_and_text;
        if (this.props.compact) {
            disp = img;
        }
        return (
            <OverlayTrigger trigger={['hover', 'focus']} overlay={popover} placement="left">
                {disp}
            </OverlayTrigger>
        );
    }
}

class Hero extends Component {
    render() {
        if (!this.props.hero_list) {
            return <span>Hero {this.props.hero_id}</span>
        }
        const hero = this.props.hero_list[this.props.hero_id];
        let elem = <span className="item-img-and-text">
            <img src={"/images/heroes/" + hero.name + ".png"} height="20" alt={hero.dname}/>
            {' '}
            {hero.dname}
        </span>;
        if (this.props.link) {
            elem = <Link to={this.props.link}>{elem}</Link>;
        }
        return elem;
    }
}

class Home extends Component {
    render() {
        set_document_title("");
        return <div>
            <p>Welcome to Dota 2 Item Recommender System! See <a href="https://ieeexplore.ieee.org/abstract/document/8395021">paper</a> in IEEE Transactions on Games.</p>
            <ul>
                <li><Link to="/hero">Hero information</Link>: For each hero, purchasing strategies identified through clustering and logistic regression.</li>
                <li><Link to="/player">Players in database</Link>: Demonstration of the system's ability to predict the next item a player will purchase.</li>
            </ul>
        </div>
    }
}

class HeroInfo extends Component {
    constructor() {
        super();
        this.state = {hero_info: null};
    }

    reload(hero_id) {
        if (hero_id) {
            this.setState({hero_info: null}, () => {
                api_call({
                    'action': 'hero_info',
                    'hero_id': hero_id
                }, (json) => {
                    this.setState({hero_info: json});
                });
            });
        } else {
            this.props.router.replace('/hero/102');
        }
    }

    componentDidMount() {
        this.reload(this.props.params.hero_id);
    }

    componentWillReceiveProps(nextProps) {
        const next_hero_id = nextProps.params.hero_id;
        if (next_hero_id !== this.props.params.hero_id) {
            this.reload(next_hero_id);
        }
    }

    render() {
        if (this.props.hero_list && this.props.params.hero_id) {
            const hero = this.props.hero_list[this.props.params.hero_id];
            let hero_info = "Loading hero";
            if (this.state.hero_info) {
                const keys = ["count", "duration", "gold_spent", "hero_healing", "hero_damage", "tower_damage", "damage_taken", "primary_lane", "win"];
                const header = keys.map((k) => {
                    return <th key={k}>{k}</th>
                });
                const subrows = this.state.hero_info.medoids.map((medoid, cn) => {
                    let stats;
                    if (this.state.hero_info.stats) {
                        this.state.hero_info.stats.forEach((s) => {
                            if (s.cluster_num === cn + 1) stats = s;
                        });
                    }
                    const cells = keys.map((key) => {
                        let d = '';
                        if (stats) {
                            d = stats[key];
                            if (key === "primary_lane") {
                                d = d.split(' ', 2);
                                d = format_lane(d[0]) + ' ' + d[1];
                            } else if (typeof d === 'number' && Math.floor(d) !== d) {
                                d = d.toFixed(2);
                            }
                        }
                        return <td key={key}>{d}</td>
                    });
                    return <tr key={cn}>
                        <td><Link to={'/match/' + medoid.MatchId + '/player_slot/' + medoid.PlayerSlot}>{cn + 1}</Link>
                        </td>
                        {cells}
                    </tr>;
                });
                let item_sets_rows;
                if (this.state.hero_info.item_sets) item_sets_rows = this.state.hero_info.item_sets.map((item_set) => {
                    const items = item_set.item_set.map((item_id, index) => {
                        return <Item compact key={index} item_id={item_id} item_list={this.props.item_list}/>;
                    });
                    return <tr key={item_set.label}>
                        <td>{item_set.label}</td>
                        <td>{items}</td>
                    </tr>;
                });
                /*const item_sets_rows = this.state.hero_info.item_sets.map((item_set) => {
                 const items = [];
                 for (const i in medoid.Items) if (medoid.Items[i]) items.push(i);
                 if (this.props.item_list) {
                 items.sort((i1, i2) => {
                 const c1 = this.props.item_list[i1].cost, c2 = this.props.item_list[i2].cost;
                 return c1 - c2;
                 });
                 }
                 const items_elems = items.map((item_id) => {
                 return <Item compact key={item_id} item_id={item_id} item_list={this.props.item_list}/>;
                 });
                 ret.push(<tr key={cn + "_items"}>
                 <td></td>
                 <td colSpan={keys.length}>{items_elems}</td>
                 </tr>);
                 });*/
                hero_info = <div>
                    <p>Click the cluster number to view the cluster medoid. Average stats (training set) are shown.</p>
                    <Table condensed>
                        <thead>
                        <tr>
                            <th>Cluster #</th>
                            {header}
                        </tr>
                        </thead>
                        <tbody>{subrows}</tbody>
                    </Table>
                    <p>Default Item Build is the first 30 items that would be purchased by a player who only purchased
                        recommended items from the start of the match.</p>
                    <Table condensed>
                        <thead>
                        <tr>
                            <th>Item Build</th>
                            <th>Default Item Build (Logistic Regression Classifier)</th>
                        </tr>
                        </thead>
                        <tbody>{item_sets_rows}</tbody>
                    </Table>
                </div>;
            }
            const all_heroes = Object.keys(this.props.hero_list).map((k) => this.props.hero_list[k]);
            all_heroes.sort((a, b) => a.dname.localeCompare(b.dname));
            const all_heroes_nav = all_heroes.map((hero) => {
                return <LinkContainer to={"/hero/" + hero.hero_id} key={hero.hero_id}>
                    <NavItem><Hero hero_id={hero.hero_id} hero_list={this.props.hero_list}/></NavItem>
                </LinkContainer>;
            });
            const doc_title = "Hero " + this.props.params.hero_id + ": " + hero.dname;
            set_document_title(doc_title);
            return <Grid>
                <Row>
                    <Col sm={2}>
                        <Nav bsStyle="pills" stacked className="heroes-nav">
                            {all_heroes_nav}
                        </Nav>
                    </Col>
                    <Col sm={10}>
                        <h2 className="mainh2">{doc_title}</h2>
                        {hero_info}
                    </Col>
                </Row>
            </Grid>;
        }
        return <p>Loading hero</p>
    }
}

class Player extends Component {
    constructor() {
        super()
        this.url_props = ['hero_id', 'skill', 'data_set', 'page'];
        this.state = {};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    reload(props) {
        // Need heroes for dropdown
        const setObj = {player_list: null};
        const req = {};
        this.url_props.forEach((prop) => {
            if (props[prop]) {
                setObj['form_' + prop] = props[prop];
                req[prop] = props[prop];
            } else {
                setObj['form_' + prop] = '';
            }
        });
        this.setState(setObj);

        req.action = 'player_list';
        api_call(req, (json) => {
            this.setState({player_list: json})
        });
    }

    componentDidMount() {
        this.reload(this.props.location.query);
    }

    componentWillReceiveProps(nextProps) {
        let reload = false;
        this.url_props.forEach((prop) => {
            if (this.props.location.query[prop] !== nextProps.location.query[prop]) {
                reload = true;
            }
        });
        if (reload) {
            this.reload(nextProps.location.query);
        }
    }

    handleChange(event) {
        this.setState({['form_' + event.target.name]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        const q = {};
        this.url_props.forEach((prop) => {
            if (this.state['form_' + prop]) {
                q[prop] = this.state['form_' + prop];
            }
        });
        this.props.router.push({pathname: '/player', query: q});
        //this.doReq();
    }

    goPage(n) {
        event.preventDefault();
        const q = Object.assign({}, this.props.location.query);
        q.page = n + ((q.page) ? parseInt(q.page, 10) : 1);
        this.props.router.push({pathname: '/player', query: q});
    }

    render() {
        let hero_options, rows = <tr>
            <td>Loading</td>
        </tr>;
        if (this.state.player_list) {
            rows = this.state.player_list.map((player) => {
                const slot_str = format_player_slot(player.player_slot);
                const date = format_unix_time(player.start_time);
                const duration = format_duration_secs(player.duration);
                return <tr key={player.match_id + '.' + player.player_slot}>
                    <td>{player.match_id}</td>
                    <td>
                        <Link to={'/match/' + player.match_id + '/player_slot/' + player.player_slot}>{slot_str}</Link>
                    </td>
                    <td><Hero hero_id={player.hero_id} hero_list={this.props.hero_list}/></td>
                    <td>{player.kills}/{player.deaths}/{player.assists}</td>
                    <td>{format_lane(player.primary_lane)}</td>
                    <td>{date}</td>
                    <td>{duration}</td>
                    <td>{format_skill(player.skill)}</td>
                    <td>{player.radiant_win ? 'Radiant' : 'Dire'}</td>
                    <td>{player.data_set}</td>
                </tr>
            });
        }
        if (this.props.hero_list) {
            const all_heroes = Object.keys(this.props.hero_list).map((k) => this.props.hero_list[k]);
            all_heroes.sort((a, b) => a.dname.localeCompare(b.dname));
            hero_options = all_heroes.map((hero) => {
                return <option value={hero.hero_id} key={hero.hero_id}>{hero.dname}</option>
            });
            hero_options.unshift(<option value="" key="">All</option>)
        }
        let cur_page = this.props.location.query.page;
        cur_page = (cur_page) ? parseInt(cur_page, 10) : 1;
        const doc_title = "Players";
        set_document_title(doc_title);
        return <div>
            <h2 className="mainh2">{doc_title}</h2>
			<p>Click on a specific player for a demonstraton of how the system is able to predict the items they purchased in that specific match.</p>
            <Form inline onSubmit={this.handleSubmit}>
                <FormGroup>
                    <ControlLabel>Hero</ControlLabel>
                    {' '}
                    <FormControl componentClass="select" value={this.state.form_hero_id} onChange={this.handleChange}
                                 name="hero_id">
                        {hero_options}
                    </FormControl>
                </FormGroup>
                {' '}
                <FormGroup>
                    <ControlLabel>Skill</ControlLabel>
                    {' '}
                    <FormControl componentClass="select" value={this.state.form_skill} onChange={this.handleChange}
                                 name="skill">
                        <option value="">All</option>
                        <option value="1">Normal</option>
                        <option value="2">High</option>
                        <option value="3">Very High</option>
                    </FormControl>
                </FormGroup>
                {' '}
                <FormGroup>
                    <ControlLabel>Data Set</ControlLabel>
                    {' '}
                    <FormControl componentClass="select" value={this.state.form_data_set} onChange={this.handleChange}
                                 name="data_set">
                        <option value="">All</option>
                        <option value="training">training</option>
                        <option value="validation">validation</option>
                        <option value="test">test</option>
                    </FormControl>
                </FormGroup>
                {' '}
                <Button type="submit">Go</Button>
            </Form>
            <Table condensed>
                <thead>
                <tr>
                    <th>Match ID</th>
                    <th>Player Slot</th>
                    <th>Hero</th>
                    <th>K/D/A</th>
                    <th>Lane</th>
                    <th>Match Date</th>
                    <th>Match Duration</th>
                    <th>Match Skill</th>
                    <th>Match Winner</th>
                    <th>Match Data Set</th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </Table>
            <Pager>
                <Pager.Item onClick={() => this.goPage(-1)} disabled={cur_page === 1}>Previous</Pager.Item>
                <Pager.Item onClick={() => this.goPage(1)}>Next</Pager.Item>
            </Pager>
        </div>
    }
}

class TransactionList extends Component {
    constructor() {
        super();
        this.state = {show_hidden: false};
        this.handleCheckbox = this.handleCheckbox.bind(this);
    }

    handleCheckbox(event) {
        this.setState({show_hidden: event.target.checked});
    }

    render() {
        const rows = this.props.transactions.map((transaction, trIndex) => {
            return transaction.RHS.map((purchase, index) => {
                if (!this.state.show_hidden && this.props.item_list && this.props.item_list[purchase.ItemId].banned) return null;
                // Note: index should be stable as there is a fixed order of all purchases.
                // There is not really any unique ID.
                const time = format_duration_secs(purchase.Time);
                let className;
                if (trIndex === this.props.rec_index) className = 'info current-rec-row';
                else if (purchase.Time <= 0) className = 'warning';
                return <tr key={index} className={className} onClick={() => this.props.onRowClick(trIndex)}>
                    <td>{time}</td>
                    <td>{purchase.Xp}</td>
                    <td>{purchase.Gold}</td>
                    <td>{purchase.ItemId}</td>
                    <td style={{textAlign: 'left'}}><Item item_list={this.props.item_list}
                                                          item_id={purchase.ItemId}/>
                    </td>
                </tr>
            });
        });
        return <div>
            <Form inline>
                <Checkbox checked={this.state.show_hidden} onChange={this.handleCheckbox}>
                    Show consumables
                </Checkbox>
            </Form>
            <Table condensed hover className="item-table">
                <thead>
                <tr>
                    <th>Time</th>
                    <th>Total XP</th>
                    <th>Total Gold</th>
                    <th>Item ID</th>
                    <th style={{textAlign: 'left'}}>Item</th>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </Table>
        </div>
    }
}

class RecommendationsList extends Component {
    render() {
        if (!this.props.rec_results) {
            return <p>Loading recommendations</p>;
        }
        if (this.props.rec_results.error) {
            return <p>{this.props.rec_results.error}</p>;
        }
        const actual_rhs = {};
        const tr = this.props.transactions[this.props.rec_index];
        if (tr.RHS[0].Time <= 0) {
            for (const tr of this.props.transactions) {
                if (tr.RHS[0].Time > 0) break;
                tr.RHS.forEach((transaction) => {
                    actual_rhs[transaction.ItemId] = true;
                });
            }
        } else {
            tr.RHS.forEach((transaction) => {
                actual_rhs[transaction.ItemId] = true;
            });
        }
        if (!this.props.rec_results.recommended) {
            return <p>No recommendations</p>
        }
        let is_logit = false;
        const rec_rows = this.props.rec_results.recommended.map((item) => {
            const row_class = (actual_rhs[item.ItemId]) ? "success" : "danger";
            if (item.FPMRule) {
                const rule_support = item.FPMRule.Support.toFixed(5);
                const rule_confidence = item.FPMRule.Confidence.toFixed(3);
                const rule_lift = item.FPMRule.Lift.toFixed(3);
                let lhs_items;
                if (item.FPMRule.LHS && item.FPMRule.LHS.length > 0) {
                    lhs_items = item.FPMRule.LHS.map((item_id, index) => {
                        if (item_id === -1) {
                            return <span key={index}>ST</span>
                        } else {
                            return <Item key={index} item_list={this.props.item_list} item_id={item_id} compact/>
                        }
                    });
                } else {
                    lhs_items = '(none)'
                }
                return [<tr key={item.ItemId} className={row_class}>
                    <td>{item.ItemId}</td>
                    <td style={{textAlign: 'left'}} rowSpan="2">
                        <Item item_list={this.props.item_list} item_id={item.ItemId}/>
                    </td>
                    <td>{rule_support}</td>
                    <td>{rule_confidence}</td>
                    <td>{rule_lift}</td>
                </tr>,
                    <tr key={item.ItemId + '_fpm'} className={row_class}>
                        <td></td>
                        <td colSpan="3">{lhs_items} &rarr; <Item item_list={this.props.item_list}
                                                                 item_id={item.FPMRule.RHS} compact/></td>
                    </tr>];
            } else {
                is_logit = true;
                const logit_score = item.LogitScore.toFixed(3);
                return <tr key={item.ItemId} className={row_class}>
                    <td>{item.ItemId}</td>
                    <td style={{textAlign: 'left'}}>
                        <Item item_list={this.props.item_list} item_id={item.ItemId}/>
                    </td>
                    <td>{logit_score}</td>
                </tr>
            }
        });
        const header = (is_logit) ? <th>Probability</th> : [<th key="0">Rule Sup</th>, <th key="1">Rule Con</th>,
                <th key="2">Rule Lif</th>];
        return <Table condensed className="item-table">
            <thead>
            <tr>
                <th>Item ID</th>
                <th style={{textAlign: 'left'}}>Item</th>
                {header}
            </tr>
            </thead>
            <tbody>
            {rec_rows}
            </tbody>
        </Table>
    }
}

class PlayerSlot extends Component {
    constructor() {
        super();
        this.num_engines = 2;
        this.state = {
            rec_engine_0: 'fpm_inventory',
            rec_engine_1: 'logit_inventory',
            rec_index: 0
        };
        this.handleEngineChange = this.handleEngineChange.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    reload(match_id, player_slot) {
        this.setState({player_slot_info: null});
        api_call({
            action: 'player_slot_info',
            match_id: match_id,
            player_slot: player_slot,
            player_slot_info: null
        }, (json) => {
            this.setState({
                rec_engine_0: 'fpm_inventory',
                rec_engine_1: 'logit_inventory',
                rec_index: 0,
                player_slot_info: json
            }, () => {
                this.clickFirstNonConsumableRow(this.props.item_list);
            });
        });
    }

    componentDidMount() {
        this.reload(this.props.params.match_id, this.props.params.player_slot);
    }

    componentWillReceiveProps(nextProps) {
        const next_match_id = nextProps.params.match_id;
        const next_player_slot = nextProps.params.player_slot;
        if (next_match_id !== this.props.params.match_id || next_player_slot !== this.props.params.player_slot) {
            this.reload(next_match_id, next_player_slot);
        } else if (nextProps.item_list && !this.props.item_list) {
            this.clickFirstNonConsumableRow(nextProps.item_list);
        }
    }

    handleEngineChange(engineId, value) {
        this.setState({['rec_engine_' + engineId]: value}, () => {
            this.handleRowClick(this.state.rec_index);
        });
    }

    // Find first non-consumable if possible.
    clickFirstNonConsumableRow(item_list) {
        if (!this.state.player_slot_info || !this.state.player_slot_info.player_info.transactions2) return;
        let idx = 0;
        if (item_list) {
            const tr2 = this.state.player_slot_info.player_info.transactions2;
            while (idx < tr2.length && item_list[tr2[idx].RHS[0].ItemId].banned) idx++;
        }
        this.handleRowClick(idx);
    }

    handleRowClick(trIndex) {
        const tr = this.state.player_slot_info.player_info.transactions2[trIndex];
        const already_purchased_items = tr.LHS;
        const rec_gold = tr.RHS[0].Gold;
        const rec_time = tr.RHS[0].Time;
        const team = this.state.player_slot_info.team.map((player, index) => {
            return (((index < 5) === (this.props.params.player_slot < 5)) ? 'A' : 'E') + player.hero_id;
        });

        const state_obj = {
            rec_index: trIndex,
            rec_gold: rec_gold,
            rec_time: rec_time
        };

        for (let i = 0; i < this.num_engines; i++) {
            state_obj['rec_results_' + i] = null;
        }

        this.setState(state_obj, () => {
            for (let i = 0; i < this.num_engines; i++) {
                api_call({
                    'action': 'recommend_items',
                    'hero_id': this.state.player_slot_info.player_info.hero_id,
                    'engine': this.state['rec_engine_' + i],
                    'already_purchased_items': JSON.stringify(already_purchased_items),
                    'gold': this.state.rec_gold,
                    'time': this.state.rec_time,
                    'team': JSON.stringify(team)
                }, (json) => {
                    this.setState({['rec_results_' + i]: json});
                });
            }
        });
    }

    render() {
        if (this.state.player_slot_info) {
            if (!this.state.player_slot_info.player_info.transactions2) {
                return <p>Error: Player has no transactions in database. Please choose another player.</p>;
            }
            const inventory = {};
            const inventory_lhs = this.state.player_slot_info.player_info.transactions2[this.state.rec_index].LHS;
            if (inventory_lhs) inventory_lhs.forEach((item_id) => {
                if (inventory[item_id]) inventory[item_id]++; else inventory[item_id] = 1;
            });
            let lhs_rows = Object.keys(inventory).map((item_id) => {
                return <tr key={item_id}>
                    <td>{item_id}</td>
                    <td>{inventory[item_id]}</td>
                    <td style={{textAlign: 'left'}}><Item item_list={this.props.item_list} item_id={item_id}/>
                    </td>
                </tr>
            });
            if (!lhs_rows.length) {
                lhs_rows = <tr>
                    <td colSpan="3">(Inventory is empty)</td>
                </tr>
            }
            const lhs_table = <Table condensed className="item-table">
                <thead>
                <tr>
                    <th>Item ID</th>
                    <th>Count</th>
                    <th style={{textAlign: 'left'}}>Item</th>
                </tr>
                </thead>
                <tbody>
                {lhs_rows}
                </tbody>
            </Table>
            const rteam = [], dteam = [];
            this.state.player_slot_info.team.forEach((player, index) => {
                let link;
                if (player.player_slot.toString() !== this.props.params.player_slot) {
                    link = '/match/' + this.props.params.match_id + '/player_slot/' + player.player_slot;
                }
                const elem = <td key={player.hero_id}>
                    <Hero hero_id={player.hero_id} hero_list={this.props.hero_list} link={link}/>
                </td>;
                if (index < 5) rteam.push(elem); else dteam.push(elem);
            });
            const date = format_unix_time(this.state.player_slot_info.player_info.start_time);
            const duration = format_duration_secs(this.state.player_slot_info.player_info.duration);
            const slot_str = format_player_slot(this.props.params.player_slot);
            const rec_time = format_duration_secs(this.state.rec_time);
            const engines = [
                ["logit_inventory", "Logistic Regression Classifier"],
                ["fpm_inventory", "Rule-Based Classifier"]
            ];
            const engine_options = engines.map((engine) => {
                return <option key={engine[0]} value={engine[0]}>{engine[1]}</option>
            });
            const rec_lists = [];
            for (let i = 0; i < this.num_engines; i++) {
                rec_lists.push(<Col md={6} key={i}>
                    <Form inline>
                        <FormGroup key={i}>
                            <ControlLabel>Engine {i + 1}</ControlLabel>
                            {' '}
                            <FormControl componentClass="select" value={this.state['rec_engine_' + i]}
                                         onChange={(event) => {
                                             this.handleEngineChange(i, event.target.value)
                                         }}>
                                {engine_options}
                            </FormControl>
                        </FormGroup>
                    </Form>
                    <RecommendationsList item_list={this.props.item_list}
                                         transactions={this.state.player_slot_info.player_info.transactions2}
                                         rec_index={this.state.rec_index}
                                         rec_results={this.state['rec_results_' + i]}/>
                </Col>);
            }
            const doc_title = "Match " + this.props.params.match_id + " Player Slot " + slot_str;
            set_document_title(doc_title);
            return <div>
                <h2 className="mainh2">{doc_title}</h2>
                <Panel>
                    <ul className="list-inline">
                        <li><Hero hero_id={this.state.player_slot_info.player_info.hero_id}
                                  hero_list={this.props.hero_list}/></li>
                        <li>
                            <b>KDA:</b> {this.state.player_slot_info.player_info.kills}/{this.state.player_slot_info.player_info.deaths}/{this.state.player_slot_info.player_info.assists}
                        </li>
                        <li><b>Lane:</b> {format_lane(this.state.player_slot_info.player_info.primary_lane)}</li>
                        <li><b>Date:</b> {date}</li>
                        <li><b>Duration:</b> {duration}</li>
                        <li><b>Match skill:</b> {format_skill(this.state.player_slot_info.player_info.skill)}</li>
                        <li><b>Match
                            winner:</b> {this.state.player_slot_info.player_info.radiant_win ? 'Radiant' : 'Dire'}</li>
                        <li><b>Data set:</b> {this.state.player_slot_info.player_info.data_set}</li>
                    </ul>
                    <Table condensed>
                        <tbody>
                        <tr>
                            <td><b>Radiant</b></td>
                            {rteam}
                        </tr>
                        <tr>
                            <td><b>Dire</b></td>
                            {dteam}
                        </tr>
                        </tbody>
                    </Table>
                </Panel>
                <Grid>
                    <Row>
                        <Col md={4}>
                            <TransactionList item_list={this.props.item_list}
                                             rec_index={this.state.rec_index}
                                             transactions={this.state.player_slot_info.player_info.transactions2}
                                             onRowClick={this.handleRowClick}/>
                        </Col>
                        <Col md={8}>
                            <p>Click on a row to recommend at another time.</p>
                            <Panel header="Recommender system inputs">
                                <ul className="list-inline">
                                    <li>Current time: {rec_time}</li>
                                    <li>Current gold: {this.state.rec_gold}</li>
                                </ul>
                                <p>Items in inventory:</p>
                                {lhs_table}
                            </Panel>
                            <Panel header="Recommended items">
                                <Grid fluid>
                                    <Row>
                                        {rec_lists}
                                    </Row>
                                </Grid>
                            </Panel>
                        </Col>
                    </Row>
                </Grid>
            </div>
        }
        return <p>Loading</p>
    }
}

class Main extends Component {
    render() {
        return <Router history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={Home}/>
                <Route path="hero">
                    <IndexRoute component={HeroInfo}/>
                    <Route path=":hero_id" component={HeroInfo}/>
                </Route>
                <Route path="match">
                    <Route path=":match_id/player_slot/:player_slot" component={PlayerSlot}/>
                </Route>
                <Route path="player" component={Player}/>
            </Route>
        </Router>
    }
}

function api_call(query, fn) {
    var params = Object.keys(query)
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(query[key]))
        .join("&");
    fetch('/api/?' + params).then((response) => {
        return response.json()
    }).then(fn);
}

function format_unix_time(ut) {
    return new Date(ut * 1000).toDateString();
}

function format_duration_secs(duration) {
    const mm = (duration < 0) ? '-' : '';
    duration = Math.abs(duration);
    const durationMin = Math.floor(duration / 60);
    let durationSec = duration - durationMin * 60;
    if (durationSec < 10) durationSec = '0' + durationSec;
    return mm + durationMin + ':' + durationSec;
}

function format_lane(lane) {
    if (!lane) return "Unknown";
    const lanes = [null, "Safelane", "Midlane", "Offlane", "Jungle"];
    return lanes[lane];
}

function format_player_slot(slot) {
    return ((slot & (1 << 7)) ? 'D' : 'R') + (slot & (~(1 << 7))) + ' (' + slot + ')';
}

function format_skill(skill) {
    if (!skill) return "Unknown";
    const skills = [null, "Normal", "High", "Very High"];
    return skills[skill];
}

function set_document_title(title) {
    if (title) {
        document.title = title + " - Dota 2 Item Recommender System";
    } else {
        document.title = "Dota 2 Item Recommender System";
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/App.js